:host{display:flex;flex-direction:column;width:100%;gap:8px}.feedback-button-container{width:100%;display:flex;justify-content:flex-end}mat-icon{color:#232426de}mat-icon{--mat-badge-background-color: #dc324f}
/*# sourceMappingURL=field-feedback-output-footer.component.css.map */
